import NotebookViewController from './NotebookViewController';
import { useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { NotebookTabs, NotebookViews } from '../../interfaces/notebook';
import { NotebookStore } from '../../stores/notebookStore/types';
import shallow from 'zustand/shallow';
import useNotebookStore from '../../stores/notebookStore';
import useHistoryWrapper from '../../hooks/useHistoryWrapper';

const notebookPageSelector = (state: NotebookStore) => ({
  toggleCurrentView: state.toggleCurrentView,
});
const NotebookController = () => {
  const history = useHistoryWrapper();
  const currentLocation = useLocation();

  const { toggleCurrentView } = useNotebookStore(notebookPageSelector, shallow);

  const hasTabView = useMemo(
    () =>
      currentLocation.pathname.includes(NotebookTabs.myWork) ||
      currentLocation.pathname.includes(NotebookTabs.ato),
    [currentLocation.pathname],
  );

  const params = useMemo(
    () => (!isEmpty(currentLocation.search) ? currentLocation.search : ''),
    [currentLocation.search],
  );

  useEffect(() => {
    const currentViewName = currentLocation.pathname.includes(
      NotebookViews.Board,
    )
      ? NotebookViews.Board
      : NotebookViews.Deadline;
    toggleCurrentView(currentViewName);
  }, [currentLocation, toggleCurrentView]);

  useEffect(() => {
    if (hasTabView) {
      history.push(`/notebook/${NotebookViews.Deadline}${params}`);
    }
  }, [hasTabView, history, params]);

  return <NotebookViewController />;
};

export default NotebookController;
